import { Action } from '@ngrx/store';
import { type } from '../../util/util';
import * as stageTypes from '../../../stage/types';
import * as commonTypes from '../../../shared/types';

export const ActionTypes = {
    GET_STAGE: type('[Data Stage] Get Stage Data'),
    GET_STAGE_SUCCESS: type('[Data Stage] Get Stage Data Success'),
    GET_STAGE_FAIL: type('[Data Stage] Get Stage Data Failure'),
    SELECT_PAGE: type('[Data Stage] Select to navigate to a Page'),
    SELECT_PAGE_SUCCESS: type('[Data Stage] Select to navigate to a Page Success'),
    UPDATE_STAGE: type('[Data Stage] Update Current Stage'),
    UPDATE_STAGE_SUCCESS: type('[Data Stage] Update Current Stage Success'),
    UPDATE_STAGE_FAIL: type('[Data Stage] Update Current Stage Failure'),
    RESET_STAGE: type('[Data Stage] Reset stageId so that GetStageInfo and GetStageData APIs will be retriggered'),
    DOWNLOAD_ATTACHMENT: type('[Data Stage] Download attachment'),
    DOWNLOAD_ATTACHMENT_SUCCESS: type('[Data Stage] Download attachment Success'),
    DOWNLOAD_ATTACHMENT_FAIL: type('[Data Stage] Download attachment Failure'),
    DOCUMENT_CONFIRMATION: type('[Data Stage] Document Confirmation'),
    DOCUMENT_CONFIRMATION_SUCCESS: type('[Data Stage] Document Confirmation Success'),
    DOCUMENT_CONFIRMATION_FAIL: type('[Data Stage] Document Confirmation Failure'),
    SAVE_FORM_DATA: type('[Data Stage] Save Form Data and Change Page'),
    SAVE_FORM_DATA_SUCCESS: type('[Data Stage] Save Form Data Success'),
    SAVE_FORM_DATA_FAIL: type('[Data Stage] Save Form Data Failure'),
    ACCEPT_STAGE: type('[Data Stage] Call Accept Stage URL'),
    ACCEPT_STAGE_SUCCESS: type('[Data Stage] Call Accept Stage Success'),
    ACCEPT_STAGE_FAIL: type('[Data Stage] Call Accept Stage Failure'),
    SERVER_ACTION: type('[Data Stage] Any action need to connect to backend'),
    SERVER_ACTION_SUCCESS: type('[Data Stage] Server Action Success'),
    SERVER_ACTION_FAIL: type('[Data Stage] Server Action Failure'),
    SAVE_ATTACHMENT: type('[Data Stage] Call service to save blob'),
    SAVE_ATTACHMENT_SUCCESS: type('[Data Stage] Call service to save blob success'),
    SAVE_ATTACHMENT_FAIL: type('[Data Stage] Call service to save blob failure')
};

// Actions for Server Api connection
export class GetStageAction implements Action {
  readonly type = ActionTypes.GET_STAGE;
  constructor(public payload: number) {}
}

export class GetStageSuccessAction implements Action {
  readonly type = ActionTypes.GET_STAGE_SUCCESS;
  constructor(public payload: stageTypes.IStageResponse) {}
}

export class GetStageFailAction implements Action {
  readonly type = ActionTypes.GET_STAGE_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<{}>) {}
}

export class SelectPageAction implements Action {
  readonly type = ActionTypes.SELECT_PAGE;
  constructor(public payload: number) { }
}

export class SelectPageSuccessAction implements Action {
  readonly type = ActionTypes.SELECT_PAGE_SUCCESS;
  constructor(public payload: commonTypes.IPageInfo) { }
}

export class UpdateStageAction implements Action {
  readonly type = ActionTypes.UPDATE_STAGE;
  constructor(public payload: stageTypes.IAttachmentDownload) { }
}

export class UpdateStageSuccessAction implements Action {
  readonly type = ActionTypes.UPDATE_STAGE_SUCCESS;
  // payload will be a particular page of the previous stage
  constructor(public payload: number) { }
}

export class UpdateStageFailAction implements Action {
  readonly type = ActionTypes.UPDATE_STAGE_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<{}>) {}
}

export class ResetStageAction implements Action {
  readonly type = ActionTypes.RESET_STAGE;
  // payload is the specific page will be selected initially
  // if !payload or payload == 0
  // then payload = 1
  constructor(public payload: number) { }
}

export class DownloadAttachmentAction implements Action {
  readonly type = ActionTypes.DOWNLOAD_ATTACHMENT;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class DownloadAttachmentSuccessAction implements Action {
  readonly type = ActionTypes.DOWNLOAD_ATTACHMENT_SUCCESS;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class DownloadAttachmentFailAction implements Action {
  readonly type = ActionTypes.DOWNLOAD_ATTACHMENT_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<stageTypes.IAttachmentDownload>) {}
}

export class DocumentConfirmationAction implements Action {
  readonly type = ActionTypes.DOCUMENT_CONFIRMATION;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class DocumentConfirmationSuccessAction implements Action {
  readonly type = ActionTypes.DOCUMENT_CONFIRMATION_SUCCESS;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class DocumentConfirmationFailAction implements Action {
  readonly type = ActionTypes.DOCUMENT_CONFIRMATION_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<stageTypes.IAttachmentDownload>) {}
}

export class SaveFormDataAction implements Action {
  readonly type = ActionTypes.SAVE_FORM_DATA;
  // payload = { currentPageId, pageData, nextPageId}
  constructor(public payload: stageTypes.IFormData) {}
}

export class SaveFormDataSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_FORM_DATA_SUCCESS;
  // payload = { currentPageId, pageData, nextPageId}
  constructor(public payload: stageTypes.IFormData) {}
}

export class SaveFormDataFailAction implements Action {
  readonly type = ActionTypes.SAVE_FORM_DATA_FAIL;
  // payload = { currentPageId, pageData, nextPageId}
  constructor(public payload: commonTypes.IErrorResponse<stageTypes.IFormData>) {}
}

export class AcceptStageAction implements Action {
  readonly type = ActionTypes.ACCEPT_STAGE;
  constructor(public payload: any) {}
}

export class AcceptStageSuccessAction implements Action {
  readonly type = ActionTypes.ACCEPT_STAGE_SUCCESS;
  constructor(public payload: any) {}
}

export class AcceptStageFailAction implements Action {
  readonly type = ActionTypes.ACCEPT_STAGE_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<any>) {}
}

export class ServerCallAction implements Action {
  readonly type = ActionTypes.SERVER_ACTION;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class ServerCallSuccessAction implements Action {
  readonly type = ActionTypes.SERVER_ACTION_SUCCESS;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class ServerCallFailAction implements Action {
  readonly type = ActionTypes.SERVER_ACTION_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<stageTypes.IAttachmentDownload>) {}
}

export class SaveAttachmentAction implements Action {
  readonly type = ActionTypes.SAVE_ATTACHMENT;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class SaveAttachmentSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_ATTACHMENT_SUCCESS;
  constructor(public payload: stageTypes.IAttachmentDownload) {}
}

export class SaveAttachmentFailAction implements Action {
  readonly type = ActionTypes.SAVE_ATTACHMENT_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<stageTypes.IAttachmentDownload>) {}
}

export type Actions
  =
  | GetStageAction
  | GetStageSuccessAction
  | GetStageFailAction
  | SelectPageAction
  | SelectPageSuccessAction
  | UpdateStageAction
  | UpdateStageSuccessAction
  | UpdateStageFailAction
  | ResetStageAction
  | DownloadAttachmentAction
  | DownloadAttachmentSuccessAction
  | DownloadAttachmentFailAction
  | DocumentConfirmationAction
  | DocumentConfirmationSuccessAction
  | DocumentConfirmationFailAction
  | SaveFormDataAction
  | SaveFormDataSuccessAction
  | SaveFormDataFailAction
  | AcceptStageAction
  | AcceptStageSuccessAction
  | AcceptStageFailAction
  | ServerCallAction
  | ServerCallSuccessAction
  | ServerCallFailAction
  | SaveAttachmentAction
  | SaveAttachmentSuccessAction
  | SaveAttachmentFailAction;



// WEBPACK FOOTER //
// ./src/app/stateManagement/actions/data/stage.ts